import React from 'react'
import { useFormikContext } from 'formik'
import * as XLSX from 'xlsx'
import FileUpload, { EXCEL_CSV_ONLY } from 'features/forms/components/FileUpload'
import { _ } from 'utils'

const ImportInput = () => {
    const { setFieldValue } = useFormikContext()

    const handleFile = (event) => {
        const file = event?.target?.files[0]
        const extension = file?.name.split('.').pop()
        if (!EXCEL_CSV_ONLY.includes(extension)) {
            return
        }

        const reader = new FileReader()
        const rABS = !!reader.readAsBinaryString
        reader.onload = (e) => {
            /* Parse data */
            const bstr = e.target.result
            const wb = XLSX.read(bstr, {
                type: rABS ? 'binary' : 'array',
                cellDates: true,
                cellNF: false,
                cellText: false,
            })
            /* Get first worksheet */
            const wsname = wb.SheetNames[0]
            const ws = wb.Sheets[wsname]
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'dd/mm/yyyy hh:mm' })
            /* Update state */
            setFieldValue('importedColumns', data[0])
            setFieldValue(
                'importedData',
                data.slice(1).filter((item: string[]) => item.length > 0)
            )
        }
        if (rABS) reader.readAsBinaryString(file)
        else reader.readAsArrayBuffer(file)
    }

    return (
        <FileUpload
            name="importFile"
            label="Data file"
            accept={EXCEL_CSV_ONLY}
            onChange={handleFile}
            className="px-0 mt-2"
            helperText={_('import_file.accepted_file')}
        />
    )
}

export default ImportInput
